<template>
    <v-app id="app">
        <v-content style="margin-top: 0px;padding-top: 0px;">
            <v-container fluid class="m-0 p-0" style="margin-top: 0px;padding-top: 0px;">
                <router-view style="margin-top: 0px;padding-top: 0px;"></router-view>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import '@babel/polyfill';
    export default {
        computed: {
            isLoggedIn: function() { return this.$store.getters.isLoggedIn }
        },
        data: () => ({
            drawer: null
        }),
        methods: {
            logout: function() {
                this.$store.dispatch('logout')
                    .then(() => {
                        this.$router.push('/login')
                    })
            }
        },
        //created() {
        //    this.$vuetify.theme.dark = false;
        //},
        created: function() {
            this.$vuetify.theme.dark = false;
            this.$http.interceptors.response.use(undefined, function(err) {
                return new Promise(function() {
                    if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
                        this.$store.dispatch('logout')
                    }
                    throw err;
                });
            });
        },
        props: {},
    };
</script>
<style>
    @import './assets/css/app.css';
</style>